import React, { Component } from "react";
import { MainLayout } from "@containers/";

class UnderConstruction extends Component {
  public render() {
    return (
      <MainLayout>
        <p className="label redLabel">Under construction</p>
      </MainLayout>
    );
  }
}

export default UnderConstruction;
